
import React from 'react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { Bell, Settings, Plus, TrendingUp } from 'lucide-react';

export const DashboardHeader = () => {
  return (
    <Card className="bg-white shadow-lg border-0">
      <CardContent className="p-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-bold bg-gradient-to-r from-blue-600 to-pink-600 bg-clip-text text-transparent">
              Social Media Hub
            </h1>
            <p className="text-slate-600 mt-1">Manage all your social media accounts in one place</p>
          </div>
          
          <div className="flex items-center gap-3">
            <Button variant="outline" size="sm" className="gap-2">
              <TrendingUp className="w-4 h-4" />
              Analytics
            </Button>
            <Button variant="outline" size="sm" className="gap-2">
              <Bell className="w-4 h-4" />
              Notifications
            </Button>
            <Button variant="outline" size="sm" className="gap-2">
              <Settings className="w-4 h-4" />
              Settings
            </Button>
            <Button className="gap-2 bg-blue-500 text-white hover:bg-blue-600 transition-colors">
              <Plus className="w-4 h-4" />
              Create Post
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
